module.exports = __webpack_public_path__ + "static/8-266e166916a7bd2fcb55d001d7a80882.png";